<form [formGroup]="aanwerfFormGroup" (ngSubmit)="onSubmit();">

    <h3 class="mb-5 mt-5 col-md-6 underlineTitle">Horeca aanwerf calculator
    <i placement="top"
                      ngbTooltip="Pas hier parameters aan voor de module Horeca aanwerf calculator"
                      class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i></h3>

    <div class="form-row h-100">

        <div class=" col-md-3  mr-auto col-sm-12">
            <h5 class="mb-3 "><strong>RSZ</strong></h5>
            <div class="form-group">

                <div *ngIf="aanwerfFormGroup.controls.studentRSZWerknemer.errors" class="text-danger md-1">
                   {{err[0]}}
                </div>

                <label class="font-weight-bold " for="">Student RSZ werknemer:</label>
                <div class="input-group">
                    <input [(ngModel)]="aanwerfSimulator.studentRSZWerknemer" type="number"
                        formControlName="studentRSZWerknemer" name="studentRSZWerknemer" step="any" placeholder="0.00"
                        min=0 max=100 class="form-control" id="studentRSZWerknemer" required>
                    <div class="input-group-append">
                        <span class="input-group-text">%</span>
                    </div>
                </div>

            </div>

            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.studentRSZWerkgever.errors" class="text-danger md-1">
                    {{err[0]}}
                 </div>
                <label class="font-weight-bold" for="">Student RSZ werkgever:</label>
                <div class="input-group">
                    <input [(ngModel)]="aanwerfSimulator.studentRSZWerkgever" type="number"
                        formControlName="studentRSZWerkgever" name="studentRSZWerkgever" step="0.01" placeholder="0.00"
                        min=0 max=100 class="form-control" id="studentRSZWerkgever" required>
                    <div class="input-group-append">
                        <span class="input-group-text">%</span>
                    </div>
                </div>

            </div>
            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.extraRSZWerkgever.errors" class="text-danger md-1">
                    {{err[0]}}
                 </div>
                <label class="font-weight-bold" for="">Extra RSZ werkgever:</label>
                <div class="input-group">
                    <input [(ngModel)]="aanwerfSimulator.extraRSZWerkgever" type="number"
                        formControlName="extraRSZWerkgever" name="extraRSZWerkgever" step="0.01" placeholder="0.00"
                        min=0 max=100 class="form-control" id="extraRSZWerkgever" required>
                    <div class="input-group-append">
                        <span class="input-group-text">%</span>
                    </div>
                </div>

            </div>
            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.flexiRSZWerkgever.errors" class="text-danger md-1">
                    {{err[0]}}
                 </div>
                <label class="font-weight-bold" for="">Flexi RSZ werkgever:</label>
                <div class="input-group">
                    <input [(ngModel)]="aanwerfSimulator.flexiRSZWerkgever" type="number"
                        formControlName="flexiRSZWerkgever" name="flexiRSZWerkgever" step="0.01" placeholder="0.00"
                        min=0 max=100 class="form-control" id="flexiRSZWerkgever" required>
                    <div class="input-group-append">
                        <span class="input-group-text">%</span>
                    </div>
                </div>

            </div>
            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.werknemerRSZWerkgever.errors" class="text-danger md-1">
                    {{err[0]}}
                 </div>
                <label class="font-weight-bold" for="">Werknermer RSZ Werkgever:</label>
                <div class="input-group mb-3">
                    
                    <input [(ngModel)]="aanwerfSimulator.werknemerRSZWerkgever" type="number"
                        formControlName="werknemerRSZWerkgever" name="werknemerRSZWerkgever" step="0.01"
                        placeholder="0.00" min=0 class="form-control" id="werknemerRSZWerkgever" required>
                        <div class="input-group-prepend">
                            <span class="input-group-text">%</span>
                        </div>
                </div>

            </div>
            

        </div>
        <div class="col-md-3  mx-auto col-sm-12">
            <h5  style="color: white;" class="mb-3 "><strong>.</strong></h5>
            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.extraBasisBerekeningRSZ.errors" class="text-danger md-1">
                    {{err[0]}}
                 </div>
                <label class="font-weight-bold" for="">Extra basis forfait per uur:</label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">€</span>
                    </div>
                    <input [(ngModel)]="aanwerfSimulator.extraBasisBerekeningRSZ" type="number"
                        formControlName="extraBasisBerekeningRSZ" name="extraBasisBerekeningRSZ" step="0.01"
                        placeholder="0.00" min=0 class="form-control" id="extraBasisBerekeningRSZ" required>
                       
                </div>
    
            </div>
            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.extraForfaitPerUur.errors" class="text-danger md-1">
                    {{err[1]}}
                 </div>
                <label class="font-weight-bold" for="">Extra hoger forfait per uur:</label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">€</span>
                    </div>
                    <input [(ngModel)]="aanwerfSimulator.extraForfaitPerUur" type="number"
                        formControlName="extraForfaitPerUur" name="extraForfaitPerUur" step="0.01"
                        placeholder="0.00" min=0 class="form-control" id="extraForfaitPerUur" required>
                       
                </div>
    
            </div>
            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.extraForfaitPerDag.errors" class="text-danger md-1">
                    {{err[1]}}
                 </div>
                <label class="font-weight-bold" for="">Extra hoger forfait per dag:</label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">€</span>
                    </div>
                    <input [(ngModel)]="aanwerfSimulator.extraForfaitPerDag" type="number"
                        formControlName="extraForfaitPerDag" name="extraForfaitPerDag" step="0.01"
                        placeholder="0.00" min=0 class="form-control" id="extraForfaitPerDag" required>
                       
                </div>
    
            </div>

        </div>
        





        <div class=" col-md-3  mx-auto col-sm-12">
            <h5 class=" mb- m"><strong>WERKBONUS</strong></h5>
                <div class="form-group">
                    <div *ngIf="aanwerfFormGroup.controls.werkbonusdagen.errors" class="text-danger md-1">
                        {{err[1]}}
                    </div>
                    <label class="font-weight-bold" for="">Werkbonus dagen:</label>
                    <input [(ngModel)]="aanwerfSimulator.werkbonusdagen" type="number" formControlName="werkbonusdagen"
                        name="werkbonusdagen" step="1" placeholder="0.00" min=0 max=100 class="form-control"
                        id="werkbonusdagen" required>
                </div>
            <h6 class="mb-3 mt-3 s"><strong>LUIK A</strong></h6>
            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.werkbonusFactorLuikA.errors" class="text-danger md-1">
                    {{err[0]}}
                 </div>
                <label class="font-weight-bold " for="">Werkbonus factor:</label>
                <div class="input-group">
                    <input [(ngModel)]="aanwerfSimulator.werkbonusFactorLuikA" type="number"
                        formControlName="werkbonusFactorLuikA" name="werkbonusFactorLuikA" step="any" placeholder="0.00" min=0
                        max=100 class="form-control" id="werkbonusFactorLuikA" required>
                </div>

            </div>

           

            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.werkbonusOndergrensLuikA.errors" class="text-danger md-1">
                    {{err[1]}}
                 </div>
                <label class="font-weight-bold" for="">Werkbonus ondergrens: </label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">€</span>
                    </div>
                    <input [(ngModel)]="aanwerfSimulator.werkbonusOndergrensLuikA" type="number"
                        formControlName="werkbonusOndergrensLuikA" name="werkbonusOndergrensLuikA" step="0.01" placeholder="0.00"
                        min=0 class="form-control" id="werkbonusOndergrensLuikA" required>
                </div>
            </div>

            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.werkbonusMinimumLuikA.errors" class="text-danger md-1">
                    {{err[1]}}
                 </div>
                <label class="font-weight-bold" for="">Werkbonus minimum: </label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">€</span>
                    </div>
                    <input [(ngModel)]="aanwerfSimulator.werkbonusMinimumLuikA" type="number"
                        formControlName="werkbonusMinimumLuikA" name="werkbonusMinimumLuikA" step="0.01" placeholder="0.00" min=0
                        class="form-control" id="werkbonusMinimumLuikA" required>
                </div>
            </div>
            
            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.werkbonusBovengrensLuikA.errors" class="text-danger md-1">
                    {{err[1]}}
                    </div>
                <label class="font-weight-bold" for="">Werkbonus bovengrens: </label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">€</span>
                    </div>
                    <input [(ngModel)]="aanwerfSimulator.werkbonusBovengrensLuikA" type="number"
                        formControlName="werkbonusBovengrensLuikA" name="werkbonusBovengrensLuikA" step="0.01"
                        placeholder="0.00" min=0 class="form-control" id="werkbonusBovengrensLuikA" required>
                </div>
            </div>

        <h6 class=" mb-3 mt-3 s"><strong>LUIK B</strong></h6>

            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.werkbonusFactorLuikB.errors" class="text-danger md-1">
                    {{err[0]}}
                 </div>
                <label class="font-weight-bold " for="">Werkbonus factor:</label>
                <div class="input-group">
                    <input [(ngModel)]="aanwerfSimulator.werkbonusFactorLuikB" type="number"
                        formControlName="werkbonusFactorLuikB" name="werkbonusFactorLuikB" step="any" placeholder="0.00" min=0
                        max=100 class="form-control" id="werkbonusFactorLuikB" required>
                </div>
            </div>

            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.werkbonusOndergrensLuikB.errors" class="text-danger md-1">
                    {{err[1]}}
                 </div>
                <label class="font-weight-bold" for="">Werkbonus ondergrens: </label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">€</span>
                    </div>
                    <input [(ngModel)]="aanwerfSimulator.werkbonusOndergrensLuikB" type="number"
                        formControlName="werkbonusOndergrensLuikB" name="werkbonusOndergrensLuikB" step="0.01" placeholder="0.00"
                        min=0 class="form-control" id="werkbonusOndergrensLuikB" required>
                </div>
            </div>

            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.werkbonusMinimumLuikB.errors" class="text-danger md-1">
                    {{err[1]}}
                 </div>
                <label class="font-weight-bold" for="">Werkbonus minimum: </label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">€</span>
                    </div>
                    <input [(ngModel)]="aanwerfSimulator.werkbonusMinimumLuikB" type="number"
                        formControlName="werkbonusMinimumLuikB" name="werkbonusMinimumLuikB" step="0.01" placeholder="0.00" min=0
                        class="form-control" id="werkbonusMinimumLuikB" required>
                </div>
            </div>

            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.werkbonusBovengrensLuikB.errors" class="text-danger md-1">
                    {{err[1]}}
                    </div>
                <label class="font-weight-bold" for="">Werkbonus bovengrens: </label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">€</span>
                    </div>
                    <input [(ngModel)]="aanwerfSimulator.werkbonusBovengrensLuikB" type="number"
                        formControlName="werkbonusBovengrensLuikB" name="werkbonusBovengrensLuikB" step="0.01"
                        placeholder="0.00" min=0 class="form-control" id="werkbonusBovengrensLuikB" required>
                </div>

            </div>
            
        </div>

        <div class="col-md-3 col-sm-12 mx-auto">
            <h5 class=" mb-3 m"><strong>ANDER</strong></h5>
            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.fondsHorecaPercentage.errors" class="text-danger md-1">
                    {{err[0]}}
                 </div>
                <label class="font-weight-bold " for="">Fonds Horeca:</label>
                <div class="input-group">
                    <input [(ngModel)]="aanwerfSimulator.fondsHorecaPercentage" type="number"
                        formControlName="fondsHorecaPercentage" name="fondsHorecaPercentage" step="any"
                        placeholder="0.00" min=0 max=100 class="form-control" id="fondsHorecaPercentage" required>
                    <div class="input-group-append">
                        <span class="input-group-text">%</span>
                    </div>
                </div>

            </div>
            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.bedrijfsVoorheffing.errors" class="text-danger md-1">
                    {{err[0]}}
                 </div>
                <label class="font-weight-bold " for="">Bedrijfsvoorheffing:</label>
                <div class="input-group">
                    <input [(ngModel)]="aanwerfSimulator.bedrijfsVoorheffing" type="number"
                        formControlName="bedrijfsVoorheffing" name="bedrijfsVoorheffing" step="any" placeholder="0.00"
                        min=0 max=100 class="form-control" id="bedrijfsVoorheffing" required>
                    <div class="input-group-append">
                        <span class="input-group-text">%</span>
                    </div>
                </div>

            </div>
            <div class="form-group">
                <div *ngIf="aanwerfFormGroup.controls.jaarlijkseVakantie.errors" class="text-danger md-1">
                    {{err[0]}}
                 </div>
                <label class="font-weight-bold " for="">Jaarlijkse vakantie:</label>
                <div class="input-group">
                    <input [(ngModel)]="aanwerfSimulator.jaarlijkseVakantie" type="number"
                        formControlName="jaarlijkseVakantie" name="jaarlijkseVakantie" step="any" placeholder="0.00"
                        min=0 max=100 class="form-control" id="jaarlijkseVakantie" required>
                    <div class="input-group-append">
                        <span class="input-group-text">%</span>
                    </div>
                </div>

            </div>
        </div>


    </div>
    <div class="mr form-row h-100"><h5 class="  mb-3 "><strong>INFO VELDEN</strong></h5></div>
    <div class="form-row">
        

            <div class="col-md-6  col-sm-12 ">
                
                <div class="form-group">
                    <div *ngIf="aanwerfFormGroup.controls.tekstBrutoUurloon.errors" class="text-danger md-1">
                        {{err[1]}}
                     </div>
                <label class="font-weight-bold " for="textArea">Bruto uurloon:</label>
                <i placement="top"
                      ngbTooltip="Licht de gebruiker in over het minimum uurloon van een individu."
                      class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i>
                <textarea [(ngModel)]="aanwerfSimulator.tekstBrutoUurloon" formControlName="tekstBrutoUurloon"
                    name="tekstBrutoUurloon" id="tekstBrutoUurloon" class="form-control" 
                    rows="3"></textarea>
                </div>
                <div class="form-group">
                    <div *ngIf="aanwerfFormGroup.controls.tekstBasisUurloon.errors" class="text-danger md-1">
                        {{err[1]}}
                     </div>
                    <label class="font-weight-bold " for="textArea">Basis uurloon:</label>
                    <i placement="top"
                      ngbTooltip="Geef de gebruiker extra uitleg over de berekening van het basis uurloon."
                      class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i>
                <textarea [(ngModel)]="aanwerfSimulator.tekstBasisUurloon" formControlName="tekstBasisUurloon"
                    name="tekstBasisUurloon" id="tekstBasisUurloon" class="form-control" 
                    rows="3"></textarea>
                </div>
                   
            </div>
            <div class="col-md-6  col-sm-12 mx-auto">
            
                <div class="form-group">
                    <div *ngIf="aanwerfFormGroup.controls.tekstFondsHoreca.errors" class="text-danger md-1">
                        {{err[1]}}
                     </div>
                    <label class="font-weight-bold " for="textArea">Fonds horeca:</label>
                    <i placement="top"
                      ngbTooltip="Geef de gebruiker extra uitleg over de berekening van fonds horeca."
                      class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i>
                    <textarea [(ngModel)]="aanwerfSimulator.tekstFondsHoreca" formControlName="tekstFondsHoreca"
                        name="tekstFondsHoreca" id="tekstFondsHoreca" class="form-control" 
                        rows="3"></textarea>
                    </div>

            </div>

    </div>
    <div class="card-bottom col-12 mobile" [ngStyle]="{'background-color': onderneming.kleur}"></div>
    <div  class="form-row">
        <div class="col-md-6   col-sm-12 "></div>
        <div class="col-md-6   col-sm-12 ">
            <button [disabled]="!aanwerfFormGroup.valid" class="btn btn-dark btn-lg float-right mt-2" type="submit">OPSLAAN</button>
        </div>

    </div>

    
</form>

